export const UPDATE_RESTAURANT_TABLE_REQUEST = 'UPDATE_RESTAURANT_TABLE_REQUEST';
export const UPDATE_RESTAURANT_TABLE_SUCCESS = 'UPDATE_RESTAURANT_TABLE_SUCCESS';
export const UPDATE_RESTAURANT_TABLE_ERROR = 'UPDATE_RESTAURANT_TABLE_ERROR';
export const GET_ALL_TABLE_REQUEST = 'GET_ALL_TABLE_REQUEST';
export const GET_ALL_TABLE_SUCCESS = 'GET_ALL_TABLE_SUCCESS';
export const GET_ALL_TABLE_ERROR = 'GET_ALL_TABLE_ERROR';
export const CREATE_TABLE_REQUEST = 'CREATE_TABLE_REQUEST';
export const CREATE_TABLE_SUCCESS = 'CREATE_TABLE_REQUEST';
export const CREATE_TABLE_ERROR = 'CREATE_TABLE_REQUEST';
